import actionTypes from '../actionTypes';

const initialState = {
	createRuleLoading: false,
	createRuleErrorCode: 0,
	hasRuleCreated: false,
	ruleType: 'Threshold',
	lastCreatedRuleName: '',

	previewMessage: null,
	previewLoading: false,

	// Drawer state
	isCreateRuleOpen: false,
	isCustomizeColOpen: false,
	isWatchListOpen: false,
	isNotificationOpen: false,

	// Search & Bulk validation items
	searchQuery: '',
	searchItemDimension: '', // or type
	locationCheckBox: {
		alertForAggregated: true,
		alertForIndividual: false,
	},
	productCheckBox: {
		alertForProductAggregated: true,
		alertForProductIndividual: false,
	},
	searchItems: {
		loading: false,
		errorCode: 0,
	},
	selectedItems: {},
	bulkSearchItems: {
		loading: false,
		errorCode: 0,
	},
	selectedItemsA: {},
	selectedItemsB: {},

	// Notifications polling
	data: [],
	polling: false,
	pollingErrorCode: 0,

	// Mark Notifications Read
	readNotification: {
		loading: false,
		errorCode: 0,
	},
	watchListData: [],
	watchListLoading: false,
	watchListErrorCode: 0,
	deleteRuleLoading: false,
	hasRuleDeleted: false,
	deactivateToggle: false,
	editRuleData: null,

	subRuleNotifications: [],
	subRuleNotificationLoading: false,
	subRuleNotificationErrorCode: 0,
};

const createRuleReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		case actionTypes.GET_RULE_TYPE: {
			return {
				...state,
				ruleType: action.payload,
			};
		}
		case actionTypes.GET_CREATE_RULE_DATA:
			return {
				...state,
				lastCreatedRuleName: '',
				createRuleLoading: true,
				previewLoading: true,
			};
		case actionTypes.GET_CREATE_RULE_SUCCESS: {
			return {
				...state,
				createRuleLoading: false,
				previewLoading: false,
				hasRuleCreated: true,
				createRuleErrorCode: 0,
				...action.payload,
			};
		}
		case actionTypes.GET_CREATE_RULE_FAILURE:
			return {
				...state,
				createRuleLoading: false,
				previewMessage: null,
				previewLoading: false,
				hasRuleCreated: false,
				createRuleErrorCode: action.payload,
			};

		case actionTypes.DELETE_RULE: {
			return {
				...state,
				deleteRuleLoading: true,
				hasRuleDeleted: false,
			};
		}

		case actionTypes.DELETE_RULE_SUCCESS: {
			return {
				...state,
				deleteRuleLoading: false,
				hasRuleDeleted: true,
			};
		}

		case actionTypes.DELETE_RULE_FAILURE: {
			return {
				...state,
				deleteRuleLoading: false,
				hasRuleDeleted: false,
			};
		}

		case actionTypes.REFRESH_WATCHLIST: {
			return {
				...state,
				deactivateToggle: action.payload,
			};
		}

		case actionTypes.GET_SEARCH_ITEM_RESULTS: {
			return {
				...state,
				searchQuery: action.payload.inputQuery,
				searchItemDimension: action.payload?.type,
				searchItems: {
					...state.searchItems,
					loading: true,
				},
			};
		}
		case actionTypes.GET_SEARCH_ITEM_RESULTS_SUCCESS: {
			return {
				...state,
				searchItems: {
					...state.searchItems,
					...action.payload,
					errorCode: 0,
					loading: false,
				},
			};
		}
		case actionTypes.GET_SEARCH_ITEM_RESULTS_FAILURE: {
			return {
				...state,
				searchItems: {
					...state.searchItems,
					...action.payload,
					loading: false,
				},
			};
		}
		case actionTypes.UPDATE_SEARCH_ITEM_RESULTS: {
			return {
				...state,
				searchItems: {
					...state.searchItems,
					...action.payload,
				},
			};
		}
		case actionTypes.UPDATE_SELECTED_ITEM: {
			return {
				...state,
				selectedItems: { ...state.selectedItems, ...action.payload },
			};
		}
		case actionTypes.UPDATE_SELECTED_ITEM_A: {
			return {
				...state,
				selectedItemsA: { ...state.selectedItemsA, ...action.payload },
			};
		}
		case actionTypes.UPDATE_SELECTED_ITEM_B: {
			return {
				...state,
				selectedItemsB: { ...state.selectedItemsB, ...action.payload },
			};
		}
		case actionTypes.UPDATE_ADD_ITEM_CHECKBOX: {
			return {
				...state,
				locationCheckBox: {
					alertForAggregated: action.payload?.alertForAggregated,
					alertForIndividual: action.payload?.alertForIndividual,
				},
			};
		}
		case actionTypes.UPDATE_ADD_PRODUCT_CHECKBOX: {
			return {
				...state,
				productCheckBox: {
					alertForProductAggregated: action.payload?.alertForProductAggregated,
					alertForProductIndividual: action.payload?.alertForProductIndividual,
				},
			};
		}
		case actionTypes.GET_BULK_ITEM_SEARCH_RESULTS: {
			return {
				...state,
				searchQuery: action.payload.inputQuery,
				searchItemDimension: action.payload?.type,
				bulkSearchItems: {
					...state.bulkSearchItems,
					loading: true,
				},
			};
		}
		case actionTypes.GET_BULK_ITEM_SEARCH_RESULTS_SUCCESS: {
			return {
				...state,
				bulkSearchItems: {
					...state.bulkSearchItems,
					...action.payload,
					errorCode: 0,
					loading: false,
				},
			};
		}
		case actionTypes.GET_BULK_ITEM_SEARCH_RESULTS_FAILURE: {
			return {
				...state,
				bulkSearchItems: {
					...state.bulkSearchItems,
					...action.payload,
					loading: false,
				},
			};
		}
		case actionTypes.UPDATE_BULK_ITEM_SEARCH_RESULTS: {
			return {
				...state,
				bulkSearchItems: {
					...state.bulkSearchItems,
					...action.payload,
				},
			};
		}
		case actionTypes.POLL_START:
			return {
				...state,
				polling: true,
			};
		case actionTypes.GET_DATA_SUCCESS:
			return {
				...state,
				data: action.payload,
				polling: false,
				pollingErrorCode: 0,
			};
		case actionTypes.GET_DATA_FAILURE:
			return {
				...state,
				polling: false,
				pollingErrorCode: action.payload,
			};
		case actionTypes.PUT_NOTIFICATIONS_READ: {
			return {
				...state,
				readNotification: {
					loading: true,
				},
			};
		}
		case actionTypes.PUT_NOTIFICATIONS_READ_SUCCESS: {
			return {
				...state,
				readNotification: {
					loading: false,
				},
			};
		}
		case actionTypes.PUT_NOTIFICATIONS_READ_FAILURE: {
			return {
				...state,
				readNotification: {
					loading: false,
					errorCode: action.payload,
				},
			};
		}

		case actionTypes.GET_WATCH_LIST:
			return {
				...state,
				watchListLoading: true,
			};
		case actionTypes.GET_WATCH_LIST_SUCCESS:
			return {
				...state,
				watchListData: action.payload,
				watchListErrorCode: 0,
				watchListLoading: false,
			};
		case actionTypes.GET_WATCH_LIST_FAILURE:
			return {
				...state,
				watchListErrorCode: action.payload,
				watchListLoading: false,
			};
		case actionTypes.SET_IS_CREATE_RULE_OPEN:
			return {
				...state,
				isCreateRuleOpen: action.payload,
			};

		case actionTypes.SET_IS_CUSTOMIZE_COL_OPEN:
			return {
				...state,
				isCustomizeColOpen: action.payload,
			};
		case actionTypes.SET_IS_WATCH_LIST_OPEN:
			return {
				...state,
				isWatchListOpen: action.payload,
			};
		case actionTypes.SET_IS_NOTIFICATION_OPEN:
			return {
				...state,
				isNotificationOpen: action.payload,
			};
		case actionTypes.UPDATE_LAST_CREATED_RULE:
			return {
				...state,
				lastCreatedRuleName: action.payload,
			};
		case actionTypes.GET_EDIT_RULE_DATA:
			return {
				...state,
				editRuleData: action.payload,
			};
		case actionTypes.GET_SUB_RULE_NOTIFICATION:
			return {
				...state,
				subRuleNotificationLoading: true,
			};
		case actionTypes.GET_SUB_RULE_NOTIFICATION_SUCCESS:
			return {
				...state,
				subRuleNotifications: action.payload,
				subRuleNotificationErrorCode: 0,
				subRuleNotificationLoading: false,
			};
		case actionTypes.GET_SUB_RULE_NOTIFICATION_FAILURE:
			return {
				...state,
				subRuleNotificationErrorCode: action.payload,
				subRuleNotificationLoading: false,
			};

		default:
			return state;
	}
};

export default createRuleReducer;
